import ApprovePaymentPlanError from './ApprovePaymentPlanError';
class InsufficientFunds extends ApprovePaymentPlanError {
    constructor(options) {
        super('The resource funds is insufficient', options);
    }
}
export default InsufficientFunds;
